import React from "react";
import styled from "styled-components";

const BestSelling = () => {
  return <Container>BestSelling</Container>;
};
const Container = styled.div`
  padding: 3em 7%;
`;

export default BestSelling;
